import React from 'react'
import classNames from 'classnames/bind'
import styles from './CellMono.module.scss'

const cx = classNames.bind(styles)

interface CellMonoProps {
  children: React.ReactNode
}

export default function CellMono({ children }: CellMonoProps) {
  return <span className={cx('cellMono')}>{children}</span>
}
